import React, {useEffect, useState} from 'react'
import styles from './personLine.module.css'
import {Link} from "react-router-dom";

interface PersonShort {
    id: number
    first_name: string
    last_name: string
    nick_name: string
    photo: string
    number: number
    club_name: string
    club_logo: string
    role: string
    type: string
    gender: string
}

interface PersonStats {
    person_id: number;
    person_goals: number;
    person_matches: number;
    person_yellow_cards: number;
    person_red_cards: number;
}
interface PersonLineProps {
    person: PersonShort;
    personStats: PersonStats | undefined;
}

const PersonLine: React.FC<PersonLineProps> = ({ person, personStats }) => {

    return (

        <tr>
            <td className={styles.person_line_club}>
                <div className={styles.person_line_photo_container}>
                    {person.photo &&
                        <img
                            className={styles.person_line_photo}
                            src={person.photo}
                            alt={`${person.first_name} ${person.last_name}`}
                        />
                    }
                </div>

            </td>
            <td className={styles.player_name}>
                <Link to={`/persons/${person.id}`}>
                    {person.nick_name ? (
                        <span>{person.nick_name}</span>
                    ) : (
                        <>
                            <span>{person.first_name}</span>{' '}
                            <span>{person.last_name}</span>
                        </>
                    )}
                </Link>
            </td>
            <td className={styles.team}>
                <div className={styles.person_line_logo_container}>
                    {person.club_logo && <img src={person.club_logo} alt={person.club_name} />}
                </div>
            </td>
            <td>
                <div className={styles.person_line_number}>
                    {person.number}
                </div>
            </td>

            <td className={`${styles.td_width} ${styles.person_role}`}>{person.role}</td>
            <td className={styles.td_width}>{personStats?.person_matches || 0}</td>
            <td className={styles.td_width}>{personStats?.person_goals || 0}</td>
            <td className={styles.td_width}>{personStats?.person_yellow_cards || 0}</td>
            <td className={styles.td_width}>{personStats?.person_red_cards || 0}</td>
        </tr>
    )
}

export default PersonLine
